import * as ko from 'knockout';
import type { StyleModel } from '@paperbits/common/styles/styleModel';



export class StyledBindingHandler {
    constructor() {
        ko.bindingHandlers['styled'] = {
            update: async (element: HTMLElement, valueAccessor) => {
                const styleModel: StyleModel = ko.unwrap(valueAccessor());
                if (styleModel) {
                    console.warn(`Requested 'styled' for ${styleModel.key} -> ${styleModel.classNames}`);
                    // TODO(rproserpio) controllare che styleModel.classNames sia definito e perché serve il warn
                    ko.applyBindingsToNode(element, { css: styleModel.classNames }, null);
                }
            }
        };

        ko.bindingHandlers['styledInPlace'] = {
            update: async (_element: HTMLElement, valueAccessor) => {
                const styleModel: StyleModel = ko.unwrap(valueAccessor());
                if (styleModel) {
                    console.warn(`Requested 'styled' for ${styleModel.key} -> ${styleModel.classNames}`);
                }
            }
        };
    }
}